import React from "react";
import PropTypes from "prop-types";

const Filter = () => (
  <svg
    className="icon-filter"
    xmlns="http://www.w3.org/2000/svg"
    width="18pt"
    height="18pt"
    viewBox="0 0 48 48"
  >
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M17 462 c-30 -33 -19 -55 68 -142 l85 -85 0 -117 c0 -65 3 -118 6
-118 3 0 35 25 70 56 l64 56 0 62 0 61 85 85 c89 88 100 113 67 143 -16 15
-47 17 -224 17 -186 0 -206 -2 -221 -18z m430 -28 c4 -11 -21 -43 -81 -103
l-86 -86 0 -56 c0 -51 -3 -58 -40 -94 l-40 -39 0 94 0 95 -86 86 c-60 60 -85
92 -81 103 6 14 33 16 207 16 174 0 201 -2 207 -16z"
      />
    </g>
  </svg>
);

Filter.propTypes = {
  className: PropTypes.string
};

export default Filter;
